import './icon.css';

import { ComponentPropsWithoutRef, ComponentType } from 'react';

import { heroIconSizes } from '@/constants';

interface IconProps {
    icon: ComponentType<ComponentPropsWithoutRef<'svg'> & { title?: string }> | string;
    /**
     * Optional preset size. Omit to size the icon yourself via `className`
     * (e.g. for responsive widths combined with `tw-aspect-square`).
     */
    size?: '3xs'| '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
    variant?: 'default' | 'secondary' | 'destructive' | 'light' | 'dark' | 'success' | 'warning' | 'lighter-gray' | 'info';
    colorScheme?: 'normal' | 'light' | 'lighter' | 'dark' | 'darker';
    disabled?: boolean;
    className?: string;
    title?: string;
}

const Icon = ({
    icon,
    size,
    variant = 'default',
    colorScheme = 'normal',
    disabled = false,
    className,
    title
}: IconProps) => {
    const classNames = `
        glyphicon
        scoped-icon
        ${size ? heroIconSizes[size] : ''}
        icon-variant-${variant}
        ${colorScheme !== 'normal' ? `icon-variant-${variant}--${colorScheme}` : ''}
        ${disabled ? 'icon-disabled' : ''}
        ${className ?? ''}
    `.trim();

    if (typeof icon === 'string') {
        return <img src={icon} alt="icon" className={classNames} title={title}/>;
    }
    const IconComponent = icon;
    return (
        <span className="icon-stroke-1_5">
            <IconComponent className={classNames} title={title}/>
        </span>
    );
};

export { Icon };
